import { BaseTextMergeContainerElement } from "./BaseTextMergeContainerElement";
import { TextMergeConfiguration } from "../TextMergeConfiguration";
import { ITestingContext } from "../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../Common/Data/ExecutionData/ExecutionData";
import { DataUtilities } from "../../Common/DataUtilities";
import { IDataDefinition } from "../../Common/Data/Definitions/IDataDefinition";
import { UndefinedDataDefinition } from "../../Common/Data/Definitions/UndefinedDataDefinition";
import { DataDefinition } from "../../Common/Data/DataDefinition";
import { DataTypes } from "../../Common/Data/DataTypes";
import { StateManager } from "../../Common/StateManager";
import type { AppGlueAny } from "../../Common/AppGlueAny";

export class IterationTextMergeElement extends BaseTextMergeContainerElement {
    readonly __type: string = "iteration_element";
    readonly name: string = "Iteration";
    readonly ordinal: number = 6;
    readonly styleElement: boolean = false;

    private _itemName: string = "item";

    get itemName(): string {
        return this._itemName;
    }

    set itemName(value: string) {
        this._itemName = value;
        StateManager.propertyChanged(this, "itemName");
    }

    private _path: string | undefined;

    get path(): string | undefined {
        return this._path;
    }

    set path(value: string | undefined) {
        this._path = value;
        StateManager.propertyChanged(this, "path");
    }

    override canAdd(_config: TextMergeConfiguration): boolean {
        return true;
    }

    getHTMLTag(): string {
        return "";
    }

    override getStorageData(): object {
        let data = super.getStorageData();

        DataUtilities.addStorageData(this, data, "itemName", "path");

        return data;
    }

    override setStorageData(d: object) {
        super.setStorageData(d);

        DataUtilities.setStorageData(this, d, "itemName", "path");
    }

    override output(
        data: ExecutionData,
        config: TextMergeConfiguration,
        testContext: ITestingContext | undefined,
    ): string {
        // change data out for each...

        if (!this._path) return "";

        let arrayData = DataUtilities.get(data.values, this._path!) as AppGlueAny[];

        let s = "";
        let itemExecutionData = new ExecutionData({ ...data.values });
        if (arrayData && arrayData.length !== 0) {
            for (let i of arrayData) {
                itemExecutionData.set(this._itemName, i);
                s = s + super.output(itemExecutionData, config, testContext);
            }
        }

        return s;
    }

    getItemDataDefinition(): IDataDefinition {
        if (!this._path) return new UndefinedDataDefinition();

        let dd = DataUtilities.getFieldFromDataDefinitionByName(this.parent!.getInputData().fields, this._path!);

        if (!dd) return new UndefinedDataDefinition();

        let newDef = DataUtilities.createDataDefinitionFromDataType(dd.type);
        newDef.name = this._itemName;

        if (dd.type === DataTypes.OBJECT) newDef.fields = dd.fields;

        return newDef;
    }

    override getInputData(): DataDefinition {
        let item = this.getItemDataDefinition();

        if (item.type === DataTypes.UNDEFINED) return super.getInputData();

        let superData = super.getInputData();
        let newData = new DataDefinition();
        newData.fields = [...superData.fields];
        newData.fields.push(item);

        return newData;
    }
}
